<template lang="pug">
  v-row
    v-col
      div(v-if="$route.name !== 'GroupView'")
        v-list-item(class="pl-0")
          v-list-item-content
            v-list-item-title
              h1(class="mb-2") Группы
          v-list-item-action
            v-btn(
              v-if="isOrganization" :to="{ name: 'GroupCreate' }"
              color="success" class="px-3" rounded
            )
              v-icon(class="mr-1" small) mdi-plus
              | Добавить группу
        v-row
          v-col(v-if="loading" class="text-center" key="test" cols="12")
            v-progress-circular(size="70" color="primary" indeterminate)
          v-col(v-for="group in groups" cols="12" md="4" sm="6" :key="group.id" class="group-tile")
            v-hover(v-slot="{ hover }")
              v-card(class="sdo-card" min-height="200px")
                v-img(
                  class="align-end"
                  height="200px"
                  @click="$router.push({ name: 'GroupView', params: { groupId: group.id }})"
                  src="https://img.freepik.com/free-vector/group-people-illustration-set_52683-33806.jpg"
                )
                  v-row(style="position: absolute; top:10px; width: 100%").ma-0.pr-2
                    v-spacer
                    v-scale-transition
                      tooltip-wrap(
                        v-if="hover"
                        text="Удалить группу"
                      )
                        v-btn(
                          fab small color="error"
                          @click.stop="openDeleteGroup(group.id)"
                        )
                          v-icon mdi-delete
                v-card-title {{ group.short_name }}
                v-card-text {{ group.full_name }}
                v-card-actions

                  v-spacer
                  v-btn(
                    :to="{ name: 'GroupView', params: { groupId: group.id } }"
                    depressed
                    rounded
                    text
                  )
                    v-icon(class="mr-2" small) mdi-eye-outline
                    | Просмотр
                  //- v-menu(bottom left transition="slide-y-transition" offset-y)
                  //-   template(v-slot:activator="{ on }")
                  //-     v-btn(v-on="on" color="secondary" class="px-3" depressed rounded text)
                  //-       v-icon(class="mr-2" small) mdi-cog
                  //-       | Настроить
                  //-   v-list(rounded)
                  //-     v-list-item(:to="{ name: 'GroupAddUsers', params: { id: group.id }}")
                  //-       v-list-item-title
                  //-         v-icon(class="mr-4") mdi-account-multiple-plus
                  //-         | Добавить пользователей

          v-slide-y-reverse-transition
            v-col(v-if="!loading && !groups.length" class="text-center" key="test" cols="12")
              span(class="grey--text") Группы отсутствуют
      router-view(v-else-if="!$loader.isLoading")

</template>

<script>
import { mapGetters } from 'vuex';
import anime from 'animejs';

import GroupService from '@/services/API/GroupService';
import CourseService from '@/services/API/CourseService';

export default {
  name: 'CourseGroups',
  data: () => ({
    groups: [],
    loading: true,
  }),
  computed: {
    ...mapGetters({ isOrganization: 'auth/isOrganization' }),
  },
  watch: {
    '$route.name': function () {
      this.$loader.start({ target: true });
      this.getGroupList();
      this.$loader.stop();
    },
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    openDeleteGroup(id) {
      this.$modals.show('confirm-controller', {
        method: async () => {
          await this.$api.groups.deleteGroup(id);
          this.$modals.close();
          this.getGroupList();
        },
      });
    },
    getGroupList() {
      const params = {
        'per-page': 100,
        'search[prior_record_id]': this.$route.params.enrollmentId,
      };
      this.loading = true;
      GroupService.getGroupList(params)
        .then((r) => {
          this.groups = r.data.data;
          this.loading = false;
          this.animateGroupsDisplay();
        })
        .catch(() => { this.$toasted.error('Ошибка при загрузке групп', { duration: 3000 }); });
    },
    getCourseGroupList() {
      this.loading = true;
      CourseService.getCourseGroupList(this.$route.params.courseId)
        .then((r) => {
          this.groups = r.data.data;
          this.loading = false;
          this.animateGroupsDisplay();
        })
        .catch(() => { this.$toasted.error('Ошибка при загрузке групп', { duration: 3000 }); });
    },
    animateGroupsDisplay() {
      setTimeout(() => {
        anime({
          targets: '.group-tile',
          translateY: [100, 0],
          opacity: [0, 1],
          duration: 600,
          autoplay: true,
          easing: 'easeOutExpo',
          delay: anime.stagger(100),
        });
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
  .sdo-card .v-image :hover {
    cursor: pointer;
  }

  .group-tile {
    opacity: 0;
  }

</style>
